import { BreadcrumbBrandCategoryViewModel, CategoryLevel, ProductBrandViewModel } from '@/types/api'

import { PLPPages } from '@/app/(plp)/types'

const generateBreadcrumbKey = (breadcrumb: CategoryLevel[]) => {
    const lastBreadcrumbItem = breadcrumb?.at(-1)
    const nameEn = lastBreadcrumbItem?.nameEn
    const breadcrumbLength = breadcrumb?.length
    const searchParams = new URLSearchParams({ cat: `cat${breadcrumbLength}Key:${nameEn}` })
    return searchParams.toString()
}

export const getPDPBreadcrumb = (
    breadcrumb: CategoryLevel[],
    breadcrumbBrandCategory: BreadcrumbBrandCategoryViewModel | null,
    brand: ProductBrandViewModel | null
) => {
    let breadcrumbPath = ''
    let breadcrumbTitle = ''
    const brandPath = `/${PLPPages.Brands}/${brand?.slug}`

    const hasBrandCategory = !!breadcrumbBrandCategory?.slug

    const searchParams = generateBreadcrumbKey(breadcrumb)

    if (hasBrandCategory) {
        breadcrumbPath = `/${PLPPages.BrandCategoriesCombination}/${breadcrumbBrandCategory.slug}`
        breadcrumbTitle = breadcrumbBrandCategory.title || ''
    } else {
        breadcrumbPath = `${brandPath}?${searchParams.toString()}`
        breadcrumbTitle = `${breadcrumb?.at(-1)?.nameFa || ''} ${brand?.nameFa || ''}`.trim()
    }

    return {
        breadcrumbPath,
        breadcrumbTitle,
        brandPath,
    }
}
